<template>
  <card>
    <list
      v-if="$store.state.user.sections['organizations']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "season",
      fields: [
        {
          col: " col-12 col-md-8",
          key: "name",
          label: "Название организации",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_organization",
      itemLink: "organizations",
      setLink: "organizations",
      columns: [
        {
          key: "name",
          title: "Название организации",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>

